export default __webpack_public_path__ + "static/media/FinishWalnut.8eccfdb0.png";